import type {
  ModButtonProps,
  ModDividerProps
} from '@moderneinc/design-system-components';
import {
  ModButton,
  ModDivider,
  ModMenuItem
} from '@moderneinc/design-system-components';
import {
  semanticColors,
  spacing,
  typography
} from '@moderneinc/design-system-tokens';
import { styled } from '@mui/material';
import { Link } from '../utilities/moderne-link/moderne-link.component';

export const NavigationMenuItem = styled(ModMenuItem)({
  margin: 0,
  padding: 0,
  // Full-width so non-button rows (e.g. the theme control) can space-between.
  width: '100%'
});

export const NavigationMenuItemButton = styled(
  ({ external, ...props }: ModButtonProps & { external?: boolean }) =>
    props.href ? (
      <ModButton<typeof Link>
        variant="tertiary"
        size="medium"
        sx={{ width: '100%' }}
        {...(props as unknown as ModButtonProps<typeof Link>)}
        component={Link}
        external={external}
      />
    ) : (
      <ModButton
        variant="tertiary"
        size="medium"
        sx={{ width: '100%' }}
        {...props}
      />
    )
)(() => ({
  color: semanticColors.color.icon.default,
  fontSize: 'inherit',
  textTransform: 'none',
  fontWeight: typography.fontWeight.regular,
  justifyContent: 'flex-start',
  paddingLeft: `${spacing.spacing_2}px`,
  paddingRight: `${spacing.spacing_2}px`,
  paddingTop: `${spacing.spacing_1_2}px`,
  paddingBottom: `${spacing.spacing_1_2}px`,
  '&:hover': {
    textDecoration: 'none',
    backgroundColor: semanticColors.color.surface.rowHover
  }
}));

export const MenuDivider = (props: ModDividerProps) => (
  <ModDivider
    flexItem
    variant="fullWidth"
    sx={{
      marginY: `${spacing.spacing_1_2}px`,
      borderColor: semanticColors.color.border.primary
    }}
    {...props}
  />
);
